<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <form data-vv-scope="supplier_form">
          <div class="row">
            <div class="col-lg-9">
              <div class="card rounded-5 p-lg-3 border">
                <div class="card-body form-style">
                  <div class="row mb-4">
                    <div class="col-md-6 mb-lg-0 mb-4">
                      <label for>{{$lang.messages.supplier_name}}</label><span style="color:#ff0000"> *</span>
                      <input
                        name="supplier_name"
                        v-model="obj.name"
                        v-validate="'required'"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.supplier_name') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.name"
                      />
                      <i v-show="errors.has('supplier_form.supplier_name')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.supplier_name')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_supplier_name}}</span>
                    </div>
                    <div class="col-md-6">
                      <label>{{$lang.messages.contact_number}}</label>
                      <input
                        name="contact_number"
                        v-model="obj.contact"
                        v-validate="'numeric'"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.contact_number') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.contact_number"
                      />
                      <i v-show="errors.has('supplier_form.contact_number')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.contact_number')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_contact_number}}</span>
                    </div>
                  </div>

                  <div class="row mb-4">
                    <div class="col-md-6 mb-lg-0 mb-4">
                      <label>{{$lang.messages.email}}</label>
                      <input
                        name="email"
                        v-model="obj.email"
                        v-validate="'email'"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.email') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.email"
                      />
                      <i v-show="errors.has('supplier_form.email')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.email')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_email}}</span>
                    </div>
                    <div class="col-md-6">
                      <label>{{$lang.messages.mobile_number}}</label>
                      <input
                        name="phone_number"
                        v-model="obj.phone_number"
                        v-validate="'numeric|min: 7'"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.phone_number') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.mobile_number"
                      />
                      <i v-show="errors.has('supplier_form.phone_number')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.phone_number')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_mobile_number}}</span>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-12 mb-4">
                      <label>{{$lang.messages.website}}</label>
                      <input
                        name="website"
                        v-model="obj.website"
                        v-validate="'url'"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.website') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.website"
                      />
                      <i v-show="errors.has('supplier_form.website')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.website')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_website}}</span>
                    </div>

                    <div class="col-12 mb-4">
                      <label>{{$lang.messages.address_1}}</label>
                      <input
                        name="address_1"
                        v-model="obj.address1"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.address_1') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.address_1"
                      />
                      <i v-show="errors.has('supplier_form.address_1')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.address_1')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_address_1}}</span>
                    </div>
                    <div class="col-12">
                      <label>{{$lang.messages.address_2}}</label>
                      <input
                        name="address_2"
                        v-model="obj.address2"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.address_2') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.address_2"
                      />
                      <i v-show="errors.has('supplier_form.address_2')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.address_2')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_address_2}}</span>
                    </div>
                  </div>

                  <div class="row mb-4">
                    <div class="col-md-6 mb-lg-0 mb-4">
                      <label>{{$lang.messages.city}}</label>
                      <input
                        name="city"
                        v-model="obj.city"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.city') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.city"
                      />
                      <i v-show="errors.has('supplier_form.city')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.city')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_city}}</span>
                    </div>
                    <div class="col-md-6 mb-lg-0">
                      <label>{{$lang.messages.postal_or_zip_code}}</label>
                      <input
                        name="zip_code"
                        v-model="obj.postal_code"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.zip_code') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.postal_or_zip_code"
                      />
                      <i v-show="errors.has('supplier_form.zip_code')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.zip_code')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_zip_code}}</span>
                    </div>
                  </div>

                  <div class="row mb-4">
                    <div class="col-md-6 mb-lg-0 mb-4">
                      <label>{{$lang.messages.country}}</label>
                      <div class="text-right custom-select-dd">
                        <select
                          v-model="obj.country_id"
                          name="country_id"
                          class="form-control"
                          :class="{'input': true, 'is-danger': errors.has('supplier_form.country_id') }"
                        >
                          <option value>{{$lang.messages.select_country}}</option>
                          <option
                            v-for="country in countryList"
                            :key="country.id"
                            :value="country.id"
                          >{{country.name}}</option>
                        </select>

                        <i v-show="errors.has('supplier_form.country_id')" class="fa fa-warning"></i>
                        <span
                          v-show="errors.has('supplier_form.country_id')"
                          class="help is-danger"
                        >{{$lang.messages.please_select_country}}</span>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <label>{{$lang.messages.region_state_province}}</label>
                      <input
                        name="region"
                        v-model="obj.region"
                        class="form-control"
                        :class="{'input': true, 'is-danger': errors.has('supplier_form.region') }"
                        type="text"
                        v-bind:placeholder="$lang.messages.region_state_province"
                      />
                      <i v-show="errors.has('supplier_form.region')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('supplier_form.region')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_region}}</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12 mb-4">
                      <label for>{{$lang.messages.notes}}</label>
                      <label class="float-right">{{note_count}} / 500</label>
                      <textarea
                        class="form-control"
                        v-model="obj.note"
                        rows="4"
                        v-on:keyup="changeNoteCount()"
                        :placeholder="$lang.messages.write_here_something"
                        style="height: auto"
                        maxlength="500"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-9 text-md-right text-center">
              <button
                type="button"
                class="btn btn-primary mr-3"
                @click="validateForm('supplier_form')"
              >{{$lang.messages.save_btn_text}}</button>
              <button
                type="button"
                class="btn btn-outline-primary "
                @click="$router.go(-1)"
              >{{$lang.messages.cancel_btn_text}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import { constants } from "crypto";
import router from "../../router";
export default {
  name: "SupplierView",
  components: {
    Pagination,
    ErrorComponent,
    Alert
  },
  data() {
    return {
      obj: {
        country_id: ""
      },
      countryList: [],
      id: null,
      note_count: 0
    };
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          if (scope == "supplier_form") {
            if (this.id != null) {
              this.edit();
            } else {
              this.add();
            }
          }
          return;
        }
      });
    },
    add() {

      this.$api
        .postAPI({
          _action: "/supplier/",
          _body: this.obj
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          router.push("/supplier-list");
        });
    },
    edit() {
      this.$api
        .postAPI({
          _action: "/supplier/",
          _body: this.obj
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          router.push("/supplier-list");
        });
    },
    getCountryList() {
      this.$api
        .getAPI({ _action: "/country/list" })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.countryList = res.list;
          }
        })
        .catch(e => {});
    },
    getDetail() {
      this.$api
        .getAPI({ _action: "/supplier/detail/" + this.id })
        .then(res => {
          this.obj = res;
          if (this.obj.note) {
            this.note_count = this.obj.note.length;
          }
        })
        .catch(e => {});
    },
    changeNoteCount() {
      if (this.note_count >= 500) {
        this.obj.note = this.obj.note.substring(0, 500);
        this.note_count = 500;
      }
      this.note_count = this.obj.note.length;
    }
  },
  mounted() {
    this.getCountryList();
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.getDetail();
    }
  }
};
</script>
